import { BrowserRouter, Routes, Route, Navigate, Outlet } from "react-router-dom";
import Login from "../pages/login/Login";
import Home from "../pages/home/Home";
import Agendas from "../pages/agendas/Agendas";

import Layout from "../componets/Layout";
import { AuthContext } from "../context/authContext";
import { useContext } from "react";
import Corretores from "../pages/corretores/Corretores";
import CorretorForm from "../pages/corretores/CorretorForm";
import Clientes from "../pages/clientes/Clientes";


import Logout from "../pages/logout/Logout";
import Administradores from "../pages/administradores/Administradores";
import AdministradorForm from "../pages/administradores/AdministradorForm";
import ClienteForm from "../pages/clientes/ClienteForm";
import TrocaSenha from "../pages/trocaSenha/TrocaSenha";
import ImovelForm from "../pages/imoveis/ImovelForm";
import Imoveis from "../pages/imoveis/Imoveis";
import Comodidades from "../pages/comodidades/Comodidades";
import ComodidadeForm from "../pages/comodidades/ComodidadeForm";



const PrivateRoutes = () => {
  const authContext = useContext(AuthContext);

  if (!authContext) {
    return <Navigate to="/" />;
  }

  const { user } = authContext;
  // Se o usuário estiver autenticado, renderiza o Layout com um <Outlet />
  // para as rotas filhas. Caso contrário, redireciona para o login.
  return user ? <Layout><Outlet /></Layout> : <Navigate to="/" />;
};

const LoginPage = () => {
  const authContext = useContext(AuthContext);

  if (authContext && authContext.user) {
    return <Navigate to="/home" />;
  }

  return <Login />;
}

const AppRoutes = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route element={<PrivateRoutes />}>
          <Route path="/home" element={<Home />} />
          <Route path="/administradores" element={<Outlet />}>
            <Route index element={<Administradores />} />
            <Route path="novo" element={<AdministradorForm />} />
            <Route path="editar/:id" element={<AdministradorForm />} />
          </Route>
          <Route path="/corretores" element={<Outlet />}>
            <Route index element={<Corretores />} />
            <Route path="novo" element={<CorretorForm />} />
            <Route path="editar/:id" element={<CorretorForm />} />
          </Route>
          <Route path="/clientes" element={<Outlet />}>
            <Route index element={<Clientes />} />
            <Route path="novo" element={<ClienteForm />} />
            <Route path="editar/:id" element={<ClienteForm />} />
          </Route>
          <Route path="/Imoveis" element={<Outlet />}>
            <Route index element={<Imoveis />} />
            <Route path="novo" element={<ImovelForm />} />
            <Route path="editar/:id" element={<ImovelForm />} />
          </Route>
          <Route path="/comodidades" element={<Outlet />}>
            <Route index element={<Comodidades />} />
            <Route path="novo" element={<ComodidadeForm />} />
            <Route path="editar/:id" element={<ComodidadeForm />} />
          </Route>
          <Route path="/agendas" element={<Agendas />} />
          <Route path="/logout" element={<Logout />} />
          <Route path="/trocar-senha" element={<TrocaSenha />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export default AppRoutes;